import { useState } from "react";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import AcaoButtons from "../../Shared/AcaoButtons";

export const RESULTADO_DIGITACAO_OPCOES = [
    { value: "COMPLETO", label: "Pedido completo", icone: "fa fa-check-circle" },
    { value: "PARCIAL", label: "Pedido parcial", icone: "fa fa-adjust" },
    { value: "NAO_DIGITADO", label: "Não consegui digitar", icone: "fa fa-times-circle" },
];

/**
 * Etapa "Digitação" de Solicitação e Recolhimento de Ativos — o digitador informa se fez o pedido
 * completo, parcial ou não conseguiu digitar; os campos seguintes mudam conforme a resposta
 * (mesmas regras de DigitacaoAtivosRegras no backend).
 */
export default function EtapaDigitacaoAtivos({ acoes = [], acaoEmExecucao, onExecutarAcao, texto }) {
    const [resultado, setResultado] = useState(null);
    const [numeroPedido, setNumeroPedido] = useState("");
    const [itensNaoDigitados, setItensNaoDigitados] = useState("");
    const [motivo, setMotivo] = useState("");
    const [observacao, setObservacao] = useState("");

    const pedeNumeroPedido = resultado === "COMPLETO" || resultado === "PARCIAL";
    const pedeItensNaoDigitados = resultado === "PARCIAL";
    const pedeMotivo = resultado === "PARCIAL" || resultado === "NAO_DIGITADO";

    const valido = !!resultado
        && (!pedeItensNaoDigitados || !!itensNaoDigitados.trim())
        && (!pedeMotivo || !!motivo.trim());

    function executar(acao) {
        if (!valido) return;
        onExecutarAcao(acao, {
            dados: {
                resultadoDigitacao: resultado,
                ...(pedeNumeroPedido && numeroPedido.trim() ? { numeroPedido: numeroPedido.trim() } : {}),
                ...(pedeItensNaoDigitados ? { itensNaoDigitados: itensNaoDigitados.trim() } : {}),
                ...(pedeMotivo ? { motivoDigitacao: motivo.trim() } : {}),
                ...(observacao.trim() ? { observacaoDigitacao: observacao.trim() } : {}),
            },
        });
    }

    return (
        <div className="flex flex-col gap-4">
            {texto && <p className="text-sm text-muted-foreground">{texto}</p>}

            <div className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-foreground/80">
                    Como ficou a digitação do pedido? <span className="text-destructive">*</span>
                </span>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    {RESULTADO_DIGITACAO_OPCOES.map(opcao => {
                        const ativo = resultado === opcao.value;
                        return (
                            <button
                                key={opcao.value}
                                type="button"
                                aria-pressed={ativo}
                                onClick={() => setResultado(opcao.value)}
                                className={`h-10 px-3 rounded-lg border text-sm font-medium inline-flex items-center justify-center gap-2 transition-colors ${ativo
                                    ? "bg-primary text-primary-foreground border-primary"
                                    : "bg-card text-foreground border-input hover:bg-muted"}`}
                            >
                                <i className={opcao.icone} />
                                {opcao.label}
                            </button>
                        );
                    })}
                </div>
            </div>

            {pedeNumeroPedido && (
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <Input label="Número do pedido" value={numeroPedido} onChange={e => setNumeroPedido(e.target.value)} />
                </div>
            )}

            {pedeItensNaoDigitados && (
                <Textarea
                    label="Itens não digitados"
                    required
                    placeholder="Quais itens (e quantidades) ficaram de fora do pedido?"
                    value={itensNaoDigitados}
                    onChange={e => setItensNaoDigitados(e.target.value)}
                    rows={3}
                />
            )}

            {pedeMotivo && (
                <Textarea
                    label={resultado === "PARCIAL" ? "Motivo de não ter digitado tudo" : "Motivo de não ter conseguido digitar"}
                    required
                    value={motivo}
                    onChange={e => setMotivo(e.target.value)}
                    rows={3}
                />
            )}

            {resultado && (
                <Textarea label="Observação" value={observacao} onChange={e => setObservacao(e.target.value)} rows={2} />
            )}

            <div className="flex justify-end">
                <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} disabled={!valido} />
            </div>
        </div>
    );
}
